export const fmtMoney = (n: number | string | null | undefined): string => {
  const v = typeof n === 'string' ? Number(n) : n ?? 0;
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(Number.isFinite(v) ? v : 0);
};

export const fmtDateLong = (d: Date | string): string => {
  const dd = typeof d === 'string' ? new Date(d) : d;
  return dd.toLocaleDateString('ru-RU', { weekday: 'long', day: 'numeric', month: 'long' });
};

export const fmtDateShort = (d: Date | string): string => {
  const dd = typeof d === 'string' ? new Date(d) : d;
  return dd.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
};

export const fmtDuration = (min: number): string => {
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (h && m) return `${h}ч ${m}м`;
  if (h) return `${h}ч`;
  return `${m}м`;
};

export const HHMMtoMin = (s: string): number => {
  const [h, m] = s.split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};

export const MinToHHMM = (m: number): string => {
  const hh = Math.floor(m / 60);
  const mm = m % 60;
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
};

export const addMinutesToTime = (start: string, mins: number): string =>
  MinToHHMM(HHMMtoMin(start) + mins);

/** YYYY-MM-DD in the user's local timezone (NOT UTC). */
export const dateISO = (d: Date): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
export const todayISO = (): string => dateISO(new Date());

export const STATUS_LABEL: Record<string, string> = {
  scheduled: 'Запланирована',
  confirmed: 'Подтверждена',
  in_progress: 'Идёт',
  completed: 'Завершена',
  cancelled: 'Отменена',
  rescheduled: 'Перенесена',
  no_show: 'Не пришёл',
};

export const STATUS_COLOR: Record<string, string> = {
  scheduled: 'bg-primary-soft text-primary',
  confirmed: 'bg-success-soft text-success',
  in_progress: 'bg-warning-soft text-warning',
  completed: 'bg-muted text-muted-foreground',
  cancelled: 'bg-destructive-soft text-destructive',
  rescheduled: 'bg-accent-soft text-accent',
  no_show: 'bg-warning-soft text-warning',
};

export const STATUS_DOT: Record<string, string> = {
  scheduled: 'text-primary',
  confirmed: 'text-success',
  in_progress: 'text-warning',
  completed: 'text-muted-foreground',
  cancelled: 'text-destructive',
  rescheduled: 'text-accent',
  no_show: 'text-warning',
};

export const PAYMENT_LABEL: Record<string, string> = {
  cash: 'Наличные',
  card: 'Карта',
  transfer: 'Перевод',
  debt: 'В долг',
};
